import { Text, VStack } from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import React from 'react';
import { AutoSizer, List } from 'react-virtualized';
import { HealthCoachDashboardListItem } from './HealthCoachDashboardListItem';
import { COLUMN_HEADERS, ROW_GRID, ROW_HEIGHT, ROW_PADDING_X } from './constants';

export const HealthCoachDashboardList = ({
  users,
  isFetching = false,
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  const rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    style, // Style object to be applied to row (to position it)
  }) => {
    return (
      <div key={key} style={style}>
        <HealthCoachDashboardListItem user={users[index]} key={key} />
      </div>
    );
  };

  return (
    <Box
      flex={1}
      minH={0}
      h="100%"
      w="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="grid"
        gridTemplateColumns={ROW_GRID}
        gap={4}
        px={ROW_PADDING_X}
        pb={2}
        borderBottom="1px solid"
        borderColor="cloud.200"
        flexShrink={0}
      >
        {COLUMN_HEADERS.map(({ label, sortBy: columnSortBy }) => {
          if (!columnSortBy) {
            return (
              <Text
                key={label}
                my={0}
                fontSize="xs"
                fontWeight={700}
                color="secondary.500"
              >
                {label}
              </Text>
            );
          }

          const isActive = sortBy === columnSortBy;
          const SortIcon = sortOrder === 'desc' ? ChevronDown : ChevronUp;
          const sortDescription = isActive
            ? `sorted ${sortOrder === 'desc' ? 'descending' : 'ascending'}`
            : 'not sorted';

          return (
            <Box
              key={label}
              as="button"
              type="button"
              onClick={() => onSortChange(columnSortBy)}
              aria-label={`${label}, ${sortDescription}. Click to change sort.`}
              display="flex"
              alignItems="center"
              gap={1}
              justifySelf="start"
              fontSize="xs"
              fontWeight={700}
              color="secondary.500"
              textDecoration="underline"
            >
              {label}
              {isActive && <SortIcon size={14} aria-hidden />}
            </Box>
          );
        })}
      </Box>

      {!users.length && !isFetching && (
        <VStack gap={1} pt={10} align="center">
          <Text textAlign={'center'}>
            There isn't any user with this configuration of filters.
          </Text>
          <Text textAlign={'center'}>
            Please, try to change your filter configuration in the sidebar.
          </Text>
        </VStack>
      )}

      {!!users.length && (
        <Box flex={1} minH={0} w="100%">
          <AutoSizer>
            {({ height, width }) => (
              <List
                width={width}
                height={height}
                rowCount={users.length}
                rowHeight={ROW_HEIGHT}
                rowRenderer={rowRenderer}
              />
            )}
          </AutoSizer>
        </Box>
      )}
    </Box>
  );
};
